export default {
  ESTABLISHMENTS_LIST: "Liste des établissements",
  ADD_ESTABLISHMENT: "Ajouter un établissement",
  ESTABLISHMENT_ADDED: "Établissement ajouté",
  EDIT_ESTABLISHMENT: "Modifier un établissement",
  ESTABLISHMENT_UPDATED: "Établissement mis à jour",
  DELETE_THIS_ESTABLISHMENT: "Supprimer cet établissement ?",
  ESTABLISHMENT_DELETED: "Établissement supprimé",
  BILLING_INFORMATIONS_SAME_AS_ESTABLISHMENT:
    "Même adresse que l'établissement",
  ESTABLISHMENT_TYPE_ELEMENTARY: "Primaire",
  ESTABLISHMENT_TYPE_SECONDARY: "Secondaire",
  ESTABLISHMENT_TYPE_COLLEGE: "Collégial",
  ESTABLISHMENT_TYPE_UNIVERSITY: "Universitaire",
  ESTABLISHMENT_TYPE_PROFESSIONAL: "Professionnel",
  ACTIVATE: "Activer",
  DESACTIVATE: "Désactiver",
  ACTIVE: "Actif",
  INACTIVE: "Inactif",
  ESTABLISHMENT_ACTIVATED: "Établissement activé",
  ESTABLISHMENT_DEACTIVATED: "Établissement désactivé",
  ESTABLISHMENT_INACTIVE_ALERT:
    "Cet établissement est désactivé : l'ajout de commandes, la soumission, les transferts, les factures internes, les rapports hebdomadaires et la lecture des caisses sont indisponibles.",
  DEACTIVATE_ESTABLISHMENT_TITLE: "Désactiver l'établissement",
  DEACTIVATE_ESTABLISHMENT_INTRO:
    "Vous êtes sur le point de désactiver l'établissement :",
  DEACTIVATE_RECAP_HEADER:
    "Une fois désactivé, les actions suivantes seront désactivées ou inaccessibles pour cet établissement :",
  DEACTIVATE_RECAP_ORDERS: "Ajout de commandes de vente et d'achat",
  DEACTIVATE_RECAP_SUBMISSION: "Soumission (validation) des commandes",
  DEACTIVATE_RECAP_TRANSFERS: "Création de transferts inter-établissements",
  DEACTIVATE_RECAP_INTERNAL_INVOICES: "Création de factures internes",
  DEACTIVATE_RECAP_WEEKLY_REPORTS: "Génération de rapports hebdomadaires",
  DEACTIVATE_RECAP_CASH_REGISTERS: "Lecture et saisie des caisses",
  DEACTIVATE_RECAP_ALL_LINKED:
    "Tout ajout d'élément lié à l'établissement (contacts, cafétérias, caisses, équipements, clients, entrepôt et produits, livraisons, factures, paiements, mouvements de stock…)",
  DEACTIVATE_RECAP_FOOTER:
    "Vous pourrez réactiver l'établissement à tout moment pour rétablir ces actions.",
  CONFIRM_DEACTIVATION: "Confirmer la désactivation",
  PENDING_ITEMS_TITLE: "Éléments en attente pour cet établissement",
  PENDING_LOADING: "Chargement des éléments en attente…",
  PENDING_NONE: "Aucun élément en attente.",
  PENDING_WARNING:
    "Ces éléments resteront bloqués dans leur état actuel tant que l'établissement est désactivé :",
  PENDING_SALES_ORDERS: "Soumissions en cours",
  PENDING_PURCHASES_ORDERS: "Commandes d'achat en cours",
  PENDING_SALES_DELIVERIES: "Livraisons de vente (brouillon)",
  PENDING_PURCHASES_DELIVERIES: "Livraisons d'achat (brouillon)",
  PENDING_SALES_INVOICES: "Factures de vente non finalisées",
  PENDING_PURCHASES_INVOICES: "Factures d'achat non finalisées",
  PENDING_SALES_PAYMENTS: "Paiements de vente (brouillon)",
  PENDING_PURCHASES_PAYMENTS: "Paiements d'achat (brouillon)",
  PENDING_STOCK_MOVEMENTS: "Mouvements de stock (brouillon)",
  PENDING_TRANSFERS: "Transferts en attente",
  PENDING_INTERNAL_INVOICES: "Factures internes en attente",
  PENDING_WEEKLY_REPORTS: "Rapports hebdomadaires (brouillon)",
  PENDING_CASH_REGISTER_READINGS: "Lectures de caisse (brouillon)",
  PENDING_SPECIAL_ORDER_RESERVATIONS: "Réservations de commandes spéciales en cours",
  ESTABLISHMENT_TYPE: "Type d'établissement",
  ADD_INVOICE: "Ajouter une facture",
  ADD_SALES_ORDER: "Ajouter une soumission",
  ADD_PURCHASES_ORDER: "Ajouter une commande achat",
  MANAGERS: "Gestionnaires",
  COORDINATOR: "Coordonnateur",
  ADMINISTRATION: "Administration",
  SCHOOL_LEVEL: "Niveau scolaire",
  TARGET_VALUES: "Valeurs des objectifs",
  TARGET_WAGES: "Objectifs salaires (%)",
  TARGET_CONSUMABLES: "Objectifs comestibles (%)",
  TARGET_PURCHASES: "Objectifs achats (%)",
  TARGET_NET_PROFIT: "Objectif profit net ($)",
  WEEKLY_RENT: "Loyer hebdomadaire",
  WEEKLY_REPORTS_ENABLED: "Produit des rapports hebdomadaires",
  WEEKLY_REPORTS_ENABLED_HELP:
    "Décocher pour un établissement qui ne fait pas de rapport hebdomadaire : il disparaît des menus, boutons et du tableau de bord des rapports hebdomadaires, et aucun nouveau rapport ne peut être créé. Les rapports existants restent consultables.",
  WEEKLY_RENT_TYPE: "Type de loyer hebdomadaire",
  FIXED_AMOUNT: "Montant fixe",
  DISCOUNT: "Redevance",
  SELECT_RENT_TYPE: "Sélectionner le type de loyer",
  ENTER_AMOUNT: "Entrer le montant",
  BULK_SET_TARGET_VALUES: "Définir les objectifs en lot",
  BULK_UPDATE_SUCCESS: "Objectifs mis à jour avec succès",
  CONFIGURE_DISCOUNTS: "Configurer",
  CONFIGURE_DISCOUNT_RATES: "Configurer les taux de redevance",
  CONFIGURE_DISCOUNT_RATES_BULK: "Configurer les taux de redevance (lot)",
  DISCOUNT_BULK_NOT_AVAILABLE:
    "Les redevances par source ne peuvent pas être configurées en lot. Configurez-les individuellement.",
  ISTHERA_PRODUCTS: "Produits en caisse (ISTHERA)",
  ISTHERA_DATABASE: "Base ISTHERA",
  ISTHERA_NOT_MAPPED:
    "Cet établissement n'est relié à aucune base ISTHERA.",
  ISTHERA_PROVISION: "Provisionner vers ISTHERA",
  ISTHERA_SIMULATE: "Simuler",
  ISTHERA_PURGE: "Désactiver les produits hors ERP",
  ISTHERA_PURGE_NONE: "Aucun produit actif hors ERP à désactiver.",
  ISTHERA_PURGE_CONFIRM:
    "Désactiver {count} produit(s) de la caisse absents de l'ERP ? Ils restent en base (historique conservé), simplement inactifs.",
  ISTHERA_PURGE_DONE: "{deleted} produit(s) hors ERP désactivé(s).",
  ISTHERA_PROVISION_PURGE_OPTION:
    "Désactiver aussi les produits de la caisse absents de l'ERP (rendre la caisse identique à l'ERP)",
  ISTHERA_PURGED: "Désactivés (hors ERP)",
  ISTHERA_SYNC_ONE: "Synchroniser",
  ISTHERA_SYNC_ONE_DONE: "Produit synchronisé.",
  ISTHERA_STATUS: "Statut",
  ISTHERA_ALL_STATUSES: "Tous les statuts",
  ISTHERA_ACTION_CREATE: "À créer",
  ISTHERA_ACTION_UPDATE: "À mettre à jour",
  ISTHERA_ACTION_SYNCED: "Synchronisé",
  ISTHERA_ACTION_DEACTIVATE: "À désactiver",
  ISTHERA_ACTION_LINK: "À rattacher",
  ISTHERA_ACTION_CONFLICT: "Conflit de code-barres",
  ISTHERA_IN_CAISSE: "En caisse : {value}",
  ISTHERA_IN_ERP: "Gestionnaire : {value}",
  ISTHERA_DEACTIVATE_DUPLICATE_CONFIRM:
    "Désactiver cet article de la caisse (même code-barres qu'un produit du gestionnaire) ? Il reste en base (historique conservé), simplement inactif.",
  ISTHERA_DEACTIVATE_ONE: "Désactiver",
  ISTHERA_DEACTIVATE_ONE_CONFIRM:
    "Désactiver ce produit de la caisse (absent de l'ERP) ? Il reste en base (historique conservé), simplement inactif.",
  ISTHERA_DEACTIVATE_ONE_DONE: "Produit désactivé.",
  ISTHERA_PROVISION_CONFIRM:
    "Provisionner tous les produits vendables de cet établissement vers ISTHERA ?",
  ISTHERA_PROVISION_DONE: "Provisionnement terminé",
  ISTHERA_SIMULATION_DONE: "Simulation terminée (aucune écriture)",
  ISTHERA_RESULT:
    "{created} créé(s), {updated} mis à jour, {unchanged} inchangé(s), {deactivated} désactivé(s), {errors} erreur(s)",
  ISTHERA_RUNNING: "Provisionnement en cours… {processed}/{total}",
  ISTHERA_FAILED: "Échec du provisionnement",
  ISTHERA_RESULT_TITLE: "Résultat du dernier provisionnement",
  ISTHERA_RESULT_TITLE_DRY: "Résultat de la dernière simulation",
  ISTHERA_DRY_BADGE: "Simulation : aucune écriture",
  ISTHERA_CREATED: "Créés",
  ISTHERA_UPDATED: "Mis à jour",
  ISTHERA_UNCHANGED: "Inchangés",
  ISTHERA_DEACTIVATED: "Désactivés",
  ISTHERA_ERRORS: "Erreurs",
  ISTHERA_TOTAL: "Total",
  ISTHERA_FINISHED_AT: "Terminé le",
  ISTHERA_ERROR_DETAILS: "Détail des erreurs",
  ISTHERA_ERROR_GLOBAL: "Ensemble du lot",
  ISTHERA_CODE_ACHAT: "Code achat (ISTHERA)",
  ISTHERA_CODE_BARRE: "Code-barre",
  ISTHERA_COMMENTAIREA: "SKU",
  ISTHERA_DEPARTEMENT: "Département",
  ISTHERA_SEARCH: "Rechercher (code, description, code-barre…)",
  ISTHERA_ALL_DEPARTEMENTS: "Tous les départements",
  ISTHERA_NO_RESULT: "Aucun produit ne correspond au filtre.",
  ISTHERA_ACTIVE: "Actif en caisse",
  ISTHERA_SYNC_STATUS: "État de synchro",
  ISTHERA_LINKED: "Lié à l'ERP",
};
